import { render, staticRenderFns } from "./AlertMeasurement.vue?vue&type=template&id=70936d89&scoped=true&"
import script from "./AlertMeasurement.vue?vue&type=script&lang=js&"
export * from "./AlertMeasurement.vue?vue&type=script&lang=js&"
import style0 from "./AlertMeasurement.vue?vue&type=style&index=0&id=70936d89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70936d89",
  null
  
)

/* custom blocks */
import block0 from "./AlertMeasurement.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports